// english

export default {
  blacklist_title: 'Black Device List',
  blacklist_btn_add_device: 'Add new device',

  // conifrm
  blacklist_confirm_delete_title: 'Are you sure to delete this item from the blacklist?',

  // table
  blacklist_table_sn: 'SN',
  blacklist_table_mac: 'MAC Address',
  blacklist_table_protocol_version: 'Protocol Version',
  blacklist_table_register_time: 'Register Time',
};
